"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flushTo = exports.flush = exports.navigateBack = exports.navigateTo = void 0;

var _connectedReactRouter = require("connected-react-router");

var navigateTo = function navigateTo(to) {
  return (0, _connectedReactRouter.push)(to);
};

exports.navigateTo = navigateTo;

var navigateBack = function navigateBack() {
  return (0, _connectedReactRouter.goBack)();
};

exports.navigateBack = navigateBack;

var flush = function flush() {
  return (0, _connectedReactRouter.replace)('/');
};

exports.flush = flush;

var flushTo = function flushTo(to) {
  return (0, _connectedReactRouter.replace)(to);
};

exports.flushTo = flushTo;